import { FC } from "react";

import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Stack,
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
}

const ConfirmDialog: FC<IProps> = ({
  isOpen,
  onClose,
  title,
  description
}) => {

  return (
    <Dialog
      open={isOpen}
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: 540,
          m: 2,
        },
      }}
    >
      <DialogContent>
        <Stack spacing={3} direction="row" mt={1}>
          <Box>
            <Box p={2} bgcolor={"#C6F6D5"} borderRadius={2} width={56} height={56}><CheckCircleIcon sx={{ color: "#38A169", fontSize: 24 }} /></Box>
          </Box>
          <Stack rowGap={1}>
            <Typography sx={{ fontSize: 18, fontWeight: 700 }}>{title}</Typography>
            <Typography sx={{ fontSize: 16, color: "#718096" }}>{description}</Typography>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog;
